import React, { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
type Variant = 'primary' | 'success' | 'secondary' | 'ghost' | 'bonus';
type Size = 'sm' | 'md' | 'lg';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}
const variants: Record<Variant, string> = {
  primary: 'bg-accent text-white shadow-press hover:bg-accent-ink disabled:bg-excused disabled:shadow-none',
  success: 'bg-done text-white shadow-press hover:bg-done-ink disabled:bg-excused disabled:shadow-none',
  bonus: 'bg-bonus text-white shadow-press hover:bg-bonus-ink disabled:bg-excused disabled:shadow-none',
  secondary: 'bg-surface text-ink border-[1.5px] border-line shadow-pressSoft hover:bg-canvas disabled:text-muted',
  ghost: 'bg-transparent text-ink hover:bg-canvas disabled:text-muted'
};
const sizes: Record<Size, string> = {
  sm: 'h-9 px-3 text-sm',
  md: 'h-11 px-4 text-sm',
  lg: 'h-12 px-5 text-base'
};
export function Button({
  variant = 'primary',
  size = 'md',
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  return <button type={type} className={twMerge('inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-2xl font-bold transition-[transform,background-color,box-shadow] duration-150 ease-out active:translate-y-[2px] active:shadow-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent disabled:cursor-not-allowed disabled:active:translate-y-0', variants[variant], sizes[size], className)} {...rest} data-id="element-1248" data-mp="epwe5ufm32m6" />;
}